// Function to generate WhatsApp share link
function generateWhatsAppShareLink(text: string) {
  return `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`;
}

// Function to generate Facebook share link
function generateFacebookShareLink(url: string) {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    url
  )}&amp;src=sdkpreparse`;
}

function generateTwitterShareLink(text: string) {
  return `https://twitter.com/intent/tweet?text=${text}`;
}

function generateShareInternalLink(text: string, url: string) {
  try {
    if ("share" in navigator) {
      if (navigator.canShare({ url, text }))
        return navigator.share({ url, text });
  
      return navigator.clipboard.writeText(url);
    }
  } catch (error) {
    
  }
}

export {
  generateFacebookShareLink,
  generateWhatsAppShareLink,
  generateTwitterShareLink,
  generateShareInternalLink,
};
